import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'state/hooks';

import { AppState } from '../index';
import { ApplicationModal, setOpenModal } from './slice';

export function useModalIsOpen(modal: ApplicationModal): boolean {
  const openModal = useAppSelector((state: AppState) => state.application.openModal);
  return openModal === modal;
}

export function useToggleModal(modal: ApplicationModal): () => void {
  const open = useModalIsOpen(modal);
  const dispatch = useAppDispatch();
  return useCallback(() => dispatch(setOpenModal(open ? null : modal)), [dispatch, modal, open]);
}

export function useToggleWalletModal(): () => void {
  return useToggleModal(ApplicationModal.WALLET);
}
